<template>
    <portlet
      :icon="'fad fa-bell'"
      :title="'Notifications'"
      :actionsBlock="true"
    >
        <template slot="portletBody">
            <div class="notifications-container row justify-content-between" style="margin-bottom: 1.5rem">
                <div class="col-auto">
                    <menu-section 
                        :menu="Can(rights.IS_CUSTOMER) ? menuCustomer : menu" 
                        :entry="selectedEntry"
                        @entryClick="menuClick($event)"
                    ></menu-section>
                </div>
                <div class="col-auto">
                        <reminder-create-popup v-if="showCreateReminderModal" @close="showCreateReminderModal=false" @confirmReminder="createReminder   "/>
                        <button class="btn" @click="markAllAsRead" v-if="selectedEntry.id === 1">Mark all as read</button>
                        <button class="btn" @click="showCreateReminderModal=true" v-if="selectedEntry.id === 2">Create new Reminder</button>
                </div>
            </div>
            <hr/>
            <div class="notifications-container row">
                <template v-if="selectedEntry.id === 2">
                    <reminder-update-popup
                        v-if="showUpdateReminderModal"
                        :reminder="selectedReminder"
                        @updateReminder="updateReminder"
                        @close="showUpdateReminderModal=false" 
                    />
                    <table class="table-list-h" style="width: 100%; border-spacing: 0">
                        <tbody>
                            <tr v-for="reminder in remindersData" :key="reminder.id" class="table-row" :class="reminder.active ? 'active' : 'inactive'">
                                <td>
                                    <div class="capitalized" >
                                        <span class="table-text">{{ reminder.active ? 'Active' : 'Paused' }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <span class="table-text">{{ reminder.created_at.split('T')[0] }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="capitalized" >
                                        <span class="table-text">{{ reminder.subject }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="capitalized">
                                        <span class="table-text">{{ reminder.type }}</span>                
                                    </div>
                                </td>
                                <td>
                                    <div class="capitalized">
                                        <span v-if="reminder.type ==='monthly'" class="table-text">{{ reminder.day }}</span>
                                        <span v-else-if="reminder.type ==='weekly'" class="table-text">{{ numberOfDayToName(reminder.day) }}</span>
                                        <span v-else class="table-text">{{ '-' }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="capitalized">
                                        <span class="table-text">{{ localizedTime(reminder.time) }}</span>                   
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <span @click="setActiveReminder(reminder.id, !reminder.active)">
                                            <i v-if="reminder.active" class="action-icon fa fa-pause"></i>
                                            <i v-else class="action-icon fa fa-play"></i>
                                        </span>
                                        <span @click="openUpdateReminderPopup(reminder)" class="ml-4">
                                            <i class="action-icon fa fa-pencil"></i>
                                        </span>
                                        <span @click="removeReminder(reminder.id)" class="ml-4">
                                            <i class="action-icon fa fa-trash"></i>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template v-else>
                    <table class="table-list-h" style="width: 100%; border-spacing: 0">
                        <tbody>
                            <tr v-for="notification in listedNotifications" :key="notification.id" class="table-row active">
                                <td>
                                    <div>
                                        <span class="table-text">{{ notification.created_at.split('T')[0] + ' - ' + localizedTime(notification.created_at.split('T')[1].split('.')[0]) }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="capitalized">
                                        <span class="table-text">{{ notification.owner && notification.owner.name }}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="capitalized">
                                        <span class="table-text">{{ getNotificationTypeLabel(notification.type) }}    </span>                   
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <span @click="viewNotification(notification)">
                                        <i class="action-icon fa fa-eye"></i>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <button v-if="showingHistory && historyNextCursor" class="btn mx-auto" @click="loadOlderHistory">Load older notifications</button>
                </template>
            </div>
        </template>
    </portlet>
</template>

<script>
    import Vue from 'vue';
    import store from '../../store.js';
    import { Can } from '../../../permission/ability.js';
    import { RIGHTS } from '../roles/rights';
    import menuSection from '../../components/notifications/menuSection.vue';
    import reminderCreatePopup from '../../components/notifications/reminderCreatePopup.vue';
    import reminderUpdatePopup from '../../components/notifications/reminderUpdatePopup.vue';
    import { 
        PORTAL_NOTIFICATION_TYPES, 
        PORTAL_NOTIFICATION_TYPES_LABEL,
        TYPE_HOURS_PENDING, TYPE_HOURS_APPROVED, TYPE_HOURS_REJECTED, TYPE_LEAVE_CREATED, 
        TYPE_SICKLEAVE_CREATED, 
        TYPE_CHAT_CREATED,
        TYPE_SICKLEAVE_UPDATED,
        TYPE_LEAVE_UPDATED,
        TYPE_DOCUMENT_CREATED,
        TYPE_REALLOCATE_REQUEST,
        CHAT_NOTIFICATION_TYPES
    } from '../../constants.js';
    import { describeApiOutcome } from '../../utils/apiOutcome.js';

    const HISTORY_ENTRY = { name: 'History', id: 3 };

    function ofPortalTypes(notifications) {
        return notifications.filter((notification) => PORTAL_NOTIFICATION_TYPES.includes(notification.type));
    }
    
    export default {
        components: { menuSection, reminderCreatePopup, reminderUpdatePopup },
        data() {
            return {
                selectedEntry: {id:1, name: 'Notifications'},
                menu: [{name: 'Notifications', id: 1}, {name: 'Reminders', id: 2}, HISTORY_ENTRY],
                menuCustomer: [{name: 'Notifications', id: 1}, HISTORY_ENTRY],
                remindersData: [],
                notificationsData: [],
                historyData: [],
                historyNextCursor: null,
                showCreateReminderModal: false,
                showUpdateReminderModal: false
            }
        },
        computed: {
            showingHistory() {
                return this.selectedEntry.id === HISTORY_ENTRY.id;
            },
            listedNotifications() {
                return this.showingHistory ? this.historyData : this.notificationsData;
            }
        },
        async created() {
            this.rights = RIGHTS;
            await this.fetchData(true);
        },
        mounted() {
            // Listen for global refresh notification event
            this.$root.$on('refresh-notifications', this.fetchData);
            this.listenForClaimedChats();
        },
        beforeDestroy() {
            this.$root.$off('refresh-notifications', this.fetchData);

            if (this._notificationsChannel) {
                this._notificationsChannel.stopListening('.ChatClaimed', this.refreshAfterClaim);
            }
        },
        methods: {
            Can,
            async menuClick(event) {
                if (!event) return 
                this.selectedEntry = event

                if (this.showingHistory) {
                    await this.openHistory();
                }
            },
            async openHistory() {
                const outcome = await this.fetchHistoryPage(null);

                if (outcome.ok) {
                    this.historyData = ofPortalTypes(outcome.data.data);
                    this.historyNextCursor = outcome.data.meta.next_cursor;
                }
            },
            async loadOlderHistory() {
                const cursor = this.historyNextCursor;
                const outcome = await this.fetchHistoryPage(cursor);

                if (outcome.ok && cursor === this.historyNextCursor) {
                    this.historyData = [...this.historyData, ...ofPortalTypes(outcome.data.data)];
                    this.historyNextCursor = outcome.data.meta.next_cursor;
                }
            },
            async fetchHistoryPage(cursor) {
                this.$store.commit('setLoading', true);
                const outcome = describeApiOutcome(await store.dispatch('notifications/getNotificationHistory', { ApiClient: Vue.prototype.$ApiClient, cursor }));
                this.$store.commit('setLoading', false);

                return outcome;
            },
            async markAllAsRead() {
                await store.dispatch('notifications/markAllAsViewed', { ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments }).then((res) => {
                    if (res.status === 200) {
                        //this.fetchData();
                        this.$root.$emit('refresh-notifications');
                    }
                }).catch((err) => {

                });
            },
            getNotificationTypeLabel(type) {
                return PORTAL_NOTIFICATION_TYPES_LABEL[type];
            },
            async fetchData(loading) {
                if(loading) {
                    this.$store.commit('setLoading',true);
                }

                await store.dispatch('notifications/getNotifications', { ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments }).then((res) => {
                    if (res.status === 200) {
                        this.notificationsData = ofPortalTypes(res.data.data);
                    }
                }).catch((err) => {

                });

                await store.dispatch('notifications/getAllReminders', { ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments }).then((res) => {
                    if (res.status === 200) {
                        this.remindersData = res.data.data;
                    }
                }).catch((err) => {

                });

                if(loading) {
                    this.$store.commit('setLoading',false)
                }
            },
            async listenForClaimedChats() {
                const echo = await this.$echo().catch(() => null);

                if (!echo || this._isDestroyed) {
                    return;
                }

                this._notificationsChannel = echo.private(`notifications.${this.$store.getters.getHourAppUser.id}`);
                this._notificationsChannel.listen('.ChatClaimed', this.refreshAfterClaim);
            },
            refreshAfterClaim() {
                this.$root.$emit('refresh-notifications');
            },
            async openChatNotification(notification) {
                const chatId = JSON.parse(notification.content).id;
                const apiContext = { ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments };

                if (notification.type === TYPE_CHAT_CREATED) {
                    await store.dispatch('chats/claimChat', { ...apiContext, chatId });
                }

                if (notification.type !== TYPE_REALLOCATE_REQUEST) {
                    await store.dispatch('notifications/markAsViewed', { ...apiContext, notificationId: notification.id });
                    this.$root.$emit('refresh-notifications');
                }

                this.$router.push({ name: 'chat', query: { chat: String(chatId) } });
            },
            async viewNotification (notification) {
                if (CHAT_NOTIFICATION_TYPES.includes(notification.type)) {
                    await this.openChatNotification(notification);
                    return;
                }

                this.handleNotification(notification)

                await store.dispatch('notifications/markAsViewed',
                {
                    ApiClient: Vue.prototype.$ApiClient,
                    departments: this.$store.getters.getUserData.departments,
                    notificationId: notification.id,
                }
                ).then((res) => {
                    if(res.status === 200) {
                        this.$root.$emit('refresh-notifications');
                    }
                }).catch((err) => {

                });
            },
            handleNotification(notification) {
                switch(notification.type) {
                    case TYPE_HOURS_PENDING:
                    case TYPE_HOURS_APPROVED:
                    case TYPE_HOURS_REJECTED:
                        let notificationHours = JSON.parse(notification.content)
                        
                        this.$router.push('/hours/' + notificationHours.date)
                        break;
                    case TYPE_LEAVE_CREATED:
                        let notificationLeave = JSON.parse(notification.content)
                        console.log(notificationLeave)
                        this.$router.push('/leave-requests/' + notificationLeave.employment_id + '/' + notificationLeave.employment.flexworker.user.name)
                        break;
                    case TYPE_SICKLEAVE_CREATED:
                    case TYPE_SICKLEAVE_UPDATED:
                    case TYPE_LEAVE_UPDATED:
                        this.$router.push('/')
                        break;
                    case TYPE_DOCUMENT_CREATED:
                        let notificationDocument = JSON.parse(notification.content)
                        this.$router.push('/documents/' + notificationDocument.employment_id + '/' + notificationDocument.document_category_id + '/' + notification.owner.name)
                        break;
                    //this.notificationsData = this.notificationsData.filter(n => n.id !== notification.id)
                }
            },
            openUpdateReminderPopup(reminder) {
                this.selectedReminder = reminder;
                this.showUpdateReminderModal = true;    
            },
            async createReminder(params) {
                const reminderRes = await store.dispatch('notifications/createReminder', 
                { 
                    ApiClient: Vue.prototype.$ApiClient, 
                    departments: this.$store.getters.getUserData.departments,
                    message: params.message,
                    day: params.day,
                    subject: params.subject,
                    time: moment().set({h: params.time.split(':')[0], m: params.time.split(':')[1]}).utc().format('H:mm'),
                    type: params.type,
                    userIds: params.userIds
                });
                if(reminderRes.status === 200) {
                    this.$toasted.global.successRequest({
                        message: 'Reminder created successfully'
                    });
                    await this.fetchData(true);
                }
            },
            async setActiveReminder(reminderId, active) {
                const reminderRes = await store.dispatch('notifications/setActiveOnReminder', 
                { 
                    ApiClient: Vue.prototype.$ApiClient, 
                    departments: this.$store.getters.getUserData.departments,
                    reminderId,
                    active
                });
                if(reminderRes.status === 200) {
                    this.$toasted.global.successRequest({
                        message: 'Reminder updated successfully'
                    });
                    await this.fetchData(true);
                }
            },
            async updateReminder(reminder) {
                const reminderRes = await store.dispatch('notifications/patchReminder', 
                { 
                    ApiClient: Vue.prototype.$ApiClient, 
                    departments: this.$store.getters.getUserData.departments,
                    reminder
                });
                if(reminderRes.status === 200) {
                    this.$toasted.global.successRequest({
                        message: 'Reminder updated successfully'
                    });
                    await this.fetchData(true);
                }
            },
            async removeReminder(reminderId) {
                const reminderRes = await store.dispatch('notifications/removeReminder', 
                { 
                    ApiClient: Vue.prototype.$ApiClient, 
                    departments: this.$store.getters.getUserData.departments,
                    reminderId,
                });
                if(reminderRes.status === 200) {
                    this.$toasted.global.successRequest({
                        message: 'Reminder deleted successfully'
                    });
                    await this.fetchData(true);
                }
            },
            numberOfDayToName(number) {
                const nameOfDays = ['Mon','Tue','Wed','Thu','Fri','Sat', 'Sun'];
                return nameOfDays[number - 1];
            },
            localizedTime(time) {
                return moment().utc().set({h: time.split(':')[0], m: time.split(':')[1]}).local().format('H:mm')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table-list-h {
        border-collapse: separate !important;
        border-spacing : 0 25px;
        
        td {
            text-align: center;
            padding: 3px 0px;
            .capitalized {
                text-transform: capitalize;
            }
        }
        tbody tr td div {
            padding: 10px 14px;
        }

        tbody tr.active td div {
            border: 2px solid #146F70;
            background-color: #E7F1F1;
        }

        tbody tr.inactive td div {
            border: 2px solid #FF924E;
            background-color: #FBF1EA;
        }

        tbody tr td:not(:first-child) div { border-left: 0; }
        tbody tr td:not(:last-child)  div { border-right: 0; }

        tbody tr td:first-child div { border-radius: 16px 0 0 16px; }
        tbody tr td:last-child  div { border-radius: 0 16px 16px 0; }

        .action-icon {
            font-size: 20px;
            cursor: pointer;
        }
        .table-text {
            font-size: 14px;
        }
        tr.active .table-text {
            color: #146F70;
        }
        tr.inactive .table-text {
            color: #FF924E;
        }
    }
    
    .notifications-container .btn{
        padding: 1rem 2rem;
        font-size: 1.6rem;
        border-radius: 10px;
        line-height: 1;
        color: #fff;
        font-weight: 600;
        background-color: #146F70;
        border: none;
    }
</style>